import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "value", "results", "notice"]
  static values = { options: Array, empty: String }

  connect() {
    this.picked = this.find(this.valueTarget.value)
    if (this.picked) this.queryTarget.value = this.picked[0]
    this.onOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.hide()
    }
    document.addEventListener("click", this.onOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.onOutsideClick)
  }

  filter() {
    const query = this.normalize(this.queryTarget.value)
    if (this.picked && this.normalize(this.picked[0]) !== query) {
      this.valueTarget.value = ""
      this.picked = null
      this.hideNotice()
    }
    if (query.length < 2) {
      this.hide()
      return
    }
    this.render(this.matching(query).slice(0, 8))
  }

  choose(event) {
    const button = event.target.closest("[data-nomatch], [data-id]")
    if (!button) return
    if (button.dataset.nomatch === "true") {
      this.selectNoMatch()
      return
    }
    const option = this.find(button.dataset.id)
    if (option) this.select(option)
  }

  keydown(event) {
    if (event.key !== "Enter") return
    const query = this.normalize(this.queryTarget.value)
    const matches = this.matching(query)
    if (query.length >= 2 && matches.length === 0) {
      event.preventDefault()
      this.selectNoMatch()
      return
    }
    const exact = matches.find((option) => this.names(option).some((name) => this.normalize(name) === query))
    const choice = exact || (matches.length === 1 ? matches[0] : null)
    if (!choice) return
    event.preventDefault()
    this.select(choice)
  }

  select(option) {
    this.picked = option
    this.valueTarget.value = option[1]
    this.queryTarget.value = option[0]
    this.hideNotice()
    this.hide()
  }

  selectNoMatch() {
    this.picked = [this.emptyValue, ""]
    this.valueTarget.value = ""
    this.queryTarget.value = this.emptyValue
    this.showNotice()
    this.hide()
  }

  render(matches) {
    this.resultsTarget.replaceChildren()
    if (matches.length === 0) {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "list-group-item list-group-item-action"
      button.dataset.nomatch = "true"
      button.textContent = this.emptyValue
      this.resultsTarget.appendChild(button)
    } else {
      const query = this.normalize(this.queryTarget.value)
      matches.forEach((option) => {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "list-group-item list-group-item-action"
        button.dataset.id = option[1]
        const name = document.createElement("div")
        name.textContent = option[0]
        button.appendChild(name)
        const alias = this.matchedAlias(option, query)
        if (alias) {
          const hint = document.createElement("div")
          hint.className = "small text-muted"
          hint.textContent = alias
          button.appendChild(hint)
        }
        this.resultsTarget.appendChild(button)
      })
    }
    this.resultsTarget.classList.remove("d-none")
  }

  hide() {
    this.resultsTarget.classList.add("d-none")
    this.resultsTarget.replaceChildren()
  }

  showNotice() {
    if (!this.hasNoticeTarget) return
    this.noticeTarget.classList.remove("d-none")
  }

  hideNotice() {
    if (!this.hasNoticeTarget) return
    this.noticeTarget.classList.add("d-none")
  }

  matching(query) {
    return this.optionsValue.filter((option) => this.names(option).some((name) => this.normalize(name).includes(query)))
  }

  names(option) {
    return [option[0], ...(option[2] || [])]
  }

  matchedAlias(option, query) {
    if (this.normalize(option[0]).includes(query)) return null
    return (option[2] || []).find((alias) => this.normalize(alias).includes(query)) || null
  }

  find(id) {
    if (id === undefined || id === null || id === "") return null
    return this.optionsValue.find((option) => String(option[1]) === String(id)) || null
  }

  normalize(value) {
    return (value || "").normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase()
  }
}
